import { Dispatch } from 'redux';

import { requestHandler } from '../../api';
import { DocumentConciliationRateHistory } from '../../common/GeneralComponents/DocumentProfile/components/types';
import { SurplusesReportResponse } from './types';

export const getActiveMoneyReports = async (
  dispatch: Dispatch,
  queryParams: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/report/activeMoney?${queryParams}`,
    dispatch,
  });
  if (response) return response.data;
};
export const getPlacementsChartReport = async (
  dispatch: Dispatch,
  queryParams: string,
): Promise<
  | {
      businessesNames: string[];
      stakeholdersNames: string[];
      executivesNames: string[];
      creditLines: Record<string, number>;
      mainOutput: {
        name: string;
        businessName: string;
        stakeholderName: string;
        executiveName: string;
        'Colocación total': number;
        'Colocación propia': number;
        'Colocación fondos': number;
        'Colocación sin mora': number;
        'Colocación con mora 1-30 días': number;
        'Colocación con mora 31-60 días': number;
        'Colocación con mora 61-90 días': number;
        'Colocación con mora 91+ días': number;
      }[];
    }
  | undefined
> => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/report/activeHistoryFactoring?${queryParams}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getTransactBookReport = async (
  dispatch: Dispatch,
  queryParams: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/report/transactBook?${queryParams}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getFullTransactBookReport = async (
  dispatch: Dispatch,
  queryParams: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/report/fullTransactBook?${queryParams}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getIncomeBookReport = async (
  dispatch: Dispatch,
  queryParams: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/report/incomeBook?${queryParams}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getInvoicingBookReport = async (
  dispatch: Dispatch,
  startDate: string,
  endDate: string,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/report/invoicingBook`,
    data: { startDate, endDate },
    dispatch,
  });
  if (response) return response.data;
};

export const getDocumentReport = async (
  dispatch: Dispatch,
  documentId: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/report/document/${documentId}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getCollectionReport = async (
  dispatch: Dispatch,
  query: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/report/collection?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getAccruingReport = async (dispatch: Dispatch, query: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/report/accruing?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getSurplusesReport = async (
  dispatch: Dispatch,
  query: string,
): Promise<SurplusesReportResponse | undefined> => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/report/surpluses?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getDocumentConciliationRateHistory = async (
  dispatch: Dispatch,
  documentId: string,
): Promise<DocumentConciliationRateHistory | undefined> => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/report/document/${documentId}/conciliationRateHistory`,
    dispatch,
  });
  if (response) return response.data;
};
